import { DataListModel } from './../../shared/config';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL } from '../../shared/config';
import { Location } from '@angular/common';
import { AdditionalFreeItemService } from '../models/additionalfreeitems.service';
import { AddtionalFreeItemModel } from '../models/additionalfreeitems.model';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';

@Component({
  selector: 'wego-additionalfreeitems',
  template: require('../views/additionalfreeitems-update.component.html'),
  providers: [AdditionalFreeItemService],
})

export class AdditionalFreeItemsUpdateComponent implements OnInit, OnDestroy {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  instanceHashId: string;
  sub: any;
  model: AddtionalFreeItemModel;
  additionalFreeItemList: AddtionalFreeItemModel[];
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlAdditionalItemList: string;
  dayofWeekList: any;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  isLoading: boolean;
  DataListModel: DataListModel;
  flatPickrConfigDate: FlatPickrModel;
  errorMessage: string;
  typeList: any;
  additionalFreeItemHashId: string;
  typeValue: string;

  @ViewChild('successPopup') public successPopup: any;

  constructor(private addtionaleFreeItemsService: AdditionalFreeItemService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.typeList = [
      {
        Key: 'MINUTES',
        Value: 'MINUTES'
      },
      {
        Key: 'MILEAGE',
        Value: 'MILEAGE'
      }];
    this.module = this.translate.instant('LblAdditionalFreeItems');
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.urlAdditionalItemList = this.authService.GetURL(ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST);
    this.flatPickrConfigDate = this.SetDefaultFlatPickrConfig();
    this.model = new AddtionalFreeItemModel();
    this.GetAdditionalDetails();

  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    return flatPickrConfig;
  }
  private SuccessSelectDriverSubscriptionModal($event: any) {
    this.model.sharedVehicleDriverHashId = $event.sharedVehicleDriverHashId;
    this.model.driverName = $event.driverName;

  }
  onSubmit(forms: any) {
    this.model.type = "MILEAGE";
    console.log(this.model);
    this.AddAdditionalFreeItems();
  }

  public GetAdditionalDetails() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.additionalFreeItemHashId = params['additionalFreeItemHashId'] || '';
        if (this.additionalFreeItemHashId != '') {
          this.isEditMode = true;
          this.addtionaleFreeItemsService.GetAdditionalFreeItemByHashId(this.additionalFreeItemHashId)
            .subscribe(
            res => {
              this.model = res.data;
              this.typeValue=this.model.type=="MINUTES" ? "(Minute)" : "(Kilometer)";

            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            });
        }
        else {
          this.isEditMode = false;
          this.model = new AddtionalFreeItemModel();
          this.model.type = this.typeList[1].Value;
          this.typeValue=this.model.type=="MINUTES" ? "(Minute)" : "(Kilometer)";
        }
      });
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  public AddAdditionalFreeItems() {
    this.addtionaleFreeItemsService.AddNewDriverSubscription(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      });
  }

  public OnChangeType() {
    this.typeValue=this.model.type=="MINUTES" ? "(Minute)" : "(Kilometer)";
  }
  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }
  // TODO: Remove this when we're done
  get diagnostic() { return JSON.stringify(this.model); }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/additionalfreeitem/components/additionalfreeitems-update.component.ts